import {
  VEHICLE_ALL,
  VEHICLE_GET,
  VEHICLE_DEL,
  VEHICLE_PUT,
  VEHICLE_POST,
  VEHICLE_LOADING,
  VEHICLE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const vehicleCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: VEHICLE_LOADING });
    if (payload?.file) {
      const formData = new FormData();
      formData.append('file', payload?.file);
      // console.log('Form Data', formData);
      // console.log('dddd', formData);
      const { data: uploadData } = await api.post(
        `${process.env.REACT_APP_API_URL}/upload/file`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );

      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/vehicle`,
        {
          ...payload,
          file: uploadData?.id,
        },
      );
      dispatch({ type: VEHICLE_POST, payload: data });
    } else {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/vehicle`,
        {
          ...payload,
        },
      );
      dispatch({ type: VEHICLE_POST, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLE_ERROR });
  }
};

export const vehicleAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1, statusVehicle = false } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/vehicle?licence_number=${name}&size=${size}&page=${page}&statusVehicle=${statusVehicle}`,
    );
    if (status === 200) {
      dispatch({ type: VEHICLE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLE_ERROR });
  }
};

export const vehicleGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/vehicle/${id}`,
    );
    if (status === 200) {
      dispatch({ type: VEHICLE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLE_ERROR });
  }
};

export const vehiclePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: VEHICLE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/vehicle/${id}`,
      payload,
    );
    dispatch({ type: VEHICLE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLE_ERROR });
  }
};
export const vehicleDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: VEHICLE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/vehicle/${id}`,
    );
    dispatch({ type: VEHICLE_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLE_ERROR });
  }
};
